import { connectScreenCloud } from "@screencloud/apps-sdk";
import { StudioGraphQLClient } from "@screencloud/studio-graphql-client";

let token = null;
const SERVICES_URL = "https://services.cetvnow.network/screencloud";
const CLIENT = "screencloud";
const VERSION = "1.0.6";
const SC_API_TOKEN = "a36c1ea8-f75a-49e4-b512-31d348c34e70:391a7c63d336e3b71e7bfcad04267d21";
const SC_API_URL = "https://graphql.us.screencloud.com/graphql";
const SC_CONNECT_TIMEOUT_MS = 8000;

//connectScreenCloud() never resolves or rejects if there's no ScreenCloud
//player parent frame to respond, so race it against a timeout.
function connectScreenCloudWithTimeout(timeoutMs) {
  return Promise.race([
    connectScreenCloud(),
    new Promise((_, reject) =>
      setTimeout(() => reject(new Error("Timed out waiting for the ScreenCloud SDK to connect.")), timeoutMs)
    ),
  ]);
}

function checkConfig(ext_id) {
  const config = JSON.parse(localStorage.getItem("config"));
  console.log("config", config);
  if (config && config.adServerURL && config.screenId && config.locationId) {
    console.log("config exists");
    window.location.href = `/player/index.html`;
  } else {
    console.log("config does not exist");
    getConfig(ext_id);
  }
}

//get the config
function getConfig(ext_id) {
  let url = `${SERVICES_URL}/config?ext_id=${ext_id}&client=${CLIENT}&version=${VERSION}`;

  fetch(url, {
    method: "GET",
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      }

      //if the error is 404, then let's create a screen using data from ScreenClound,
      if (response.status === 404) {
        console.log("Screen not found. Creating screen...");
        document.getElementById("message").innerText = "Screen not found.";
        return;
      }

      document.getElementById("message").innerText = "Error getting configuration.";

      throw new Error("Error getting configuration.");
    })
    .then((data) => {
      if (!data) {
        return;
      }
      data.token = token;
      document.getElementById("message").innerText = "Done. Please wait.";
      localStorage.setItem("config", JSON.stringify(data));
      window.location.href = "/player/index.html";
    })
    .catch((error) => {
      console.log("error", error);
      document.getElementById("message").innerText = "Error getting configuration.";
    });
}

//start function to connect to ScreenCloud
async function start() {
  let sc;
  try {
    sc = await connectScreenCloudWithTimeout(SC_CONNECT_TIMEOUT_MS);
  } catch (error) {
    console.log("error connecting to ScreenCloud SDK", error);
    document.getElementById("message").innerText =
      "This app must be run inside the ScreenCloud player.";
    return;
  }

  const scContext = sc.getContext();
  const ext_id = scContext.screenId;

  document.getElementById("version").innerText = `Player Version: ${CLIENT}-${VERSION}`;
  if (!ext_id) {
    console.log("No screen ID found");

    document.getElementById("message").innerText = "ScreenCloud ID not found.";
    return;
  }

  //let clear the config if there is one and start over
  localStorage.removeItem("config");

  //before checking config, let's sleep for a min so the player version can be checked
  await new Promise((resolve) => setTimeout(resolve, 4000));

  checkConfig(ext_id);
}

start();
